import { Flatfile } from '@flatfile/api-internal'

export function getInstalledApp(
  apps: Flatfile.App[],
  appClass: Flatfile.AppType,
  appId?: string
): Flatfile.App | undefined {
  return apps.find((app: Flatfile.App) => (appId ? appId === app.id : appClass === app.type))
}

export const portalAppConfig: Flatfile.AppCreate = {
  name: 'Portal',
  namespace: 'portal',
  type: Flatfile.AppType.Portal,
  entity: 'Session',
  entityPlural: 'Sessions',
  icon: 'cmd-box',
}

export const mappingAppConfig: Flatfile.AppCreate = {
  name: 'Mapping',
  namespace: 'mapping',
  type: Flatfile.AppType.Mapping,
  entity: 'Program',
  entityPlural: 'Programs',
  icon: 'map-pin-flat',
}

export const projectsAppConfig: Flatfile.AppCreate = {
  name: 'Projects',
  namespace: 'projects',
  type: Flatfile.AppType.Projects,
  entity: 'Project',
  entityPlural: 'Projects',
  icon: 'bag-2',
}

export const appConfigMap = {
  PORTAL: portalAppConfig,
  MAPPING: mappingAppConfig,
  PROJECTS: projectsAppConfig,
  WORKBOOKS: {} as Flatfile.AppCreate,
  CUSTOM: {} as Flatfile.AppCreate,
  AUTOBUILD: {} as Flatfile.AppCreate,
}
